export default __webpack_public_path__ + "static/media/Friends.fabf621b.jpg";